/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Modal, Switch, Form } from 'antd';
import { useQueryClient } from '@tanstack/react-query';
import fitLegacyServices from '../../../../services/fit-legacy.services';
import { AlertSuccess } from '../../../util/Alert';

const LegacyCategorySettingModal = ({ open, handleClose, record }) => {
  const queryClient = useQueryClient();

  const [formValues, setFormValues] = useState({
    Guest: record?.Guest ?? false,
    Distributor: record?.Distributor ?? false,
    Member: record?.Member ?? false,
    isPartner: record?.isPartner ?? false,
  });

  const { mutate: updateSetting } =
    fitLegacyServices.useMutationUpdateLegacyFitApiSetting(() => {
      queryClient.invalidateQueries({
        queryKey: ['get-legacy-fit-api-setting'],
        refetchType: 'all',
      });
      AlertSuccess('แก้ไขข้อมูลสำเร็จ');
      handleClose();
    });

  const _HandleToggle = (field, value) => {
    setFormValues((prev) => ({ ...prev, [field]: value }));
  };

  const _HandleSubmit = () => {
    updateSetting({ id: record.id, data: formValues });
  };

  return (
    <Modal
      title="ตั้งค่าการแสดงผล"
      visible={open}
      onCancel={handleClose}
      okText="บันทึก"
      cancelText="ยกเลิก"
      onOk={_HandleSubmit}
      width={400}
    >
      <Form layout="vertical">
        {[
          { key: 'Guest', label: 'ผู้ใช้งานทั่วไป (Guest)' },
          { key: 'Distributor', label: 'นักธุรกิจรหัสหลัก' },
          { key: 'isPartner', label: 'นักธุรกิจรหัสร่วม' },
          { key: 'Member', label: 'VIP Member' },
        ].map(({ key, label }) => (
          <div
            key={key}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '8px 0',
            }}
          >
            <span>{label}</span>
            <Switch
              checked={formValues[key]}
              onChange={(val) => _HandleToggle(key, val)}
              checkedChildren="เปิด"
              unCheckedChildren="ปิด"
            />
          </div>
        ))}
      </Form>
    </Modal>
  );
};

export default LegacyCategorySettingModal;
